import {
  FilterModel,
  SortModelField,
  IAction,
  ENTITY_TYPES,
} from '@shared/types';
import { Reducer } from 'redux';
import { UiActions } from '@store/actions';
import { get, merge, pick } from 'lodash';
export const DEFAULT_LIST_VIEW_NAMES: string[] = [];

const payloadItems: string[] = [
  'userViews',
  'defaultViews',
  'filterModel',
  'sortModel',
  'pageSize',
  'pageNumber',
  'quickFilter',
  'currentPage',
  'selectedColumns',
  'predefinedFilterModel',
  'extraFilterModel',
  'viewName',
];

export interface IUIListDateRange {
  dateStart: Date | string | null;
  dateEnd: Date | string | null;
  type?: string;
}

/**
 * Extra filter model for list view, can be extended for different entity types
 * !!! But now only support date range filter for all entity types with the same filter model
 *
 */
export interface IUIListExtraFilterModel {
  dateRange?: IUIListDateRange;
}

export interface IUIListState {
  entityType?: ENTITY_TYPES;
  quickFilter?: string;
  userViews?: string[];
  filterModel?: FilterModel;
  sortModel?: SortModelField[];
  currentPage?: number;
  pageSize?: number;
  selectedColumns?: string[];
  defaultViews?: string[];
  predefinedFilterModel?: FilterModel;
  extraFilterModel?: IUIListExtraFilterModel;
  entity_type?: ENTITY_TYPES;
  viewName?: string;
}

export const LIST_INITIAL_STATE: IUIListState = {
  quickFilter: '',
  userViews: [],
  currentPage: 1,
  pageSize: 50,
  defaultViews: DEFAULT_LIST_VIEW_NAMES,
  extraFilterModel: {
    dateRange: {
      dateStart: null,
      dateEnd: null,
    },
  },
};

export const uiListReducer: Reducer<IUIListState> = (
  state: IUIListState = LIST_INITIAL_STATE,
  action: IAction,
): IUIListState => {
  const { payload } = action;
  const entityType: ENTITY_TYPES = get(
    payload,
    'entity_type',
    get(payload, 'entityType', state.entityType),
  );

  switch (action.type) {
    case UiActions.UPDATE_LIST_VIEW_DATA: {
      const payloadData = pick(payload, payloadItems) as IUIListState;
      const mergedExtraFilterModel = merge(
        {},
        state.extraFilterModel,
        payloadData.extraFilterModel,
      );

      return Object.assign({}, state, payloadData, {
        entityType,
        extraFilterModel: mergedExtraFilterModel,
      });
    }

    case UiActions.SET_CURRENT_PAGE:
      return Object.assign({}, state, {
        currentPage: payload.pageNumber,
      });

    default:
      return state;
  }
};
